export type ServiceIconSize = 20 | 30 | 40 | 60 | 80 | 120 | 150;

type ServiceIconConfig = {
  /** The border radius applied to the icon. */
  borderRadius: number;
  /** The iconSize between the icon shell and the icon image. */
  iconSize: number;
  /** The spacing between two icons. Does not apply to the start or end of the list. */
  spacing: number;
};

export const ServiceIconConfig: {
  [key in ServiceIconSize]: ServiceIconConfig;
} = {
  20: {
    borderRadius: 3,
    iconSize: 14,
    spacing: 5,
  },
  30: {
    borderRadius: 3,
    iconSize: 20,
    spacing: 5,
  },
  40: {
    borderRadius: 5,
    iconSize: 30,
    spacing: 5,
  },
  60: {
    borderRadius: 8,
    iconSize: 40,
    spacing: 10,
  },
  80: {
    borderRadius: 10,
    iconSize: 60,
    spacing: 20,
  },
  120: {
    borderRadius: 15,
    iconSize: 90,
    spacing: 30,
  },
  150: {
    borderRadius: 18,
    iconSize: 110,
    spacing: 40,
  },
};

export const PDLStyleMap: {
  [key in ServiceIconSize]: any;
} = {
  20: {
    width: '--zds-size-small',
    borderRadius: '--zds-radius-small',
    iconSize: '--pdl-small-icon-size', // this variable is defined in ServiceIconShell as a workaround
  },
  30: {
    width: '--zds-size-small',
    borderRadius: '--zds-radius-small',
    iconSize: '--pdl-small-icon-size', // this variable is defined in ServiceIconShell as a workaround
  },
  40: {
    width: '--zds-size-medium',
    borderRadius: '--zds-radius-medium',
    iconSize: '--zds-size-small',
  },
  60: {
    width: '--zds-size-large',
    borderRadius: '--zds-radius-medium',
    iconSize: '--zds-size-medium',
  },
  80: {
    width: '--zds-size-large',
    borderRadius: '--zds-radius-medium',
    iconSize: '--zds-size-medium',
  },
  120: {
    width: '--zds-size-large',
    borderRadius: '--zds-radius-medium',
    iconSize: '--zds-size-medium',
  },
  150: {
    width: '--zds-size-large',
    borderRadius: '--zds-radius-medium',
    iconSize: '--zds-size-medium',
  },
};
